module.exports = __webpack_public_path__ + "img/daughter.b5a03406.jpg";